export var E_KEY_FEATURE_GUIDE_TYPE;
(function (E_KEY_FEATURE_GUIDE_TYPE) {
    E_KEY_FEATURE_GUIDE_TYPE["AUTO_UPDATE"] = "auto_update";
    E_KEY_FEATURE_GUIDE_TYPE["AI_TAGGING"] = "ai_tagging";
    E_KEY_FEATURE_GUIDE_TYPE["SHARE"] = "share";
})(E_KEY_FEATURE_GUIDE_TYPE || (E_KEY_FEATURE_GUIDE_TYPE = {}));
